// import { useEffect, useState } from 'react';
// import karliMason from '../../../assets/website/images/Karli-Mason.jpg'
// import stefanyWedge from '../../../assets/website/images/Stefany-Wedge.jpg'
// import { GetCMSDetails } from '../services/cms.services';
// import OutStorySection from './outStory';
// import Services from './services';
// import { Placeholder } from 'rsuite';


// function WebsiteAboutPage() {
//   const [pageData, setPageData] = useState(false);
//   const [dataLoaded, setDataLoaded] = useState(false);
//   useEffect(() => {
//     setDataLoaded(false);
//     GetCMSDetails("why-babe-exists").then((response) => {
//       if (response.success) {
//         setPageData(response.data)
//       }
//     }).catch((err) => {
//       console.error(err);
//     }).finally(() => {
//       setDataLoaded(true);
//     });
//   }, []);

//   const [pageFounderData, setPageFounderData] = useState(false);
//   const [founderDataLoaded, setFounderDataLoaded] = useState(false);
//   useEffect(() => {
//     setFounderDataLoaded(false);
//     GetCMSDetails("founder-desc").then((response) => {
//       if (response.success) {
//         setPageFounderData(response.data)
//       }
//     }).catch((err) => {
//       console.error(err);
//     }).finally(() => {
//       setFounderDataLoaded(true);
//     });
//   }, []);

//   return (
//     <main>
  
//       <section className="meet-founders section-padding">
//         <div className="container">
//           <div className="founders-team__header text-center">
//             <h1 className="founders-team__title">
//               Meet <em>the</em> founders
//             </h1>
//           </div>
//           <div className="row justify-content-center align-items-stretch founders-team__row g-4">
//             <div className="col-md-5 col-lg-4">
//               <article className="founders-team__card">
//                 <figure className="founders-team__photo">
//                   <img src={karliMason} alt="Karli Mason" width="200" height="200" />
//                 </figure>
//                 <h3 className="founders-team__name">Karli Mason</h3>
//                 <p className="founders-team__role">babe, Co-Founder</p>
//               </article>
//             </div>

//             <div className="col-12 d-md-none">
//               <div className="founders-team__divider-h" aria-hidden="true">
//                 <div className="founders-team__divider-h-cap">
//                   <span />
//                   <span className="founders-team__divider-heart">♥</span>
//                   <span />
//                 </div>
//                 <div className="founders-team__divider-h-line">
//                   <span className="founders-team__divider-star">✦</span>
//                 </div>
//               </div>
//             </div>

//             <div className="col-md-1 d-none d-md-flex justify-content-center">
//               <div className="founders-team__divider" aria-hidden="true">
//                 <div className="founders-team__divider-cap">
//                   <span />
//                   <span className="founders-team__divider-heart">♥</span>
//                   <span />
//                 </div>
//                 <div className="founders-team__divider-line">
//                   <span className="founders-team__divider-star">✦</span>
//                 </div>
//               </div>
//             </div>

//             <div className="col-md-5 col-lg-4">
//               <article className="founders-team__card">
//                 <figure className="founders-team__photo">
//                   <img src={stefanyWedge} alt="Stefany Wedge" width="200" height="200" />
//                 </figure>
//                 <h3 className="founders-team__name">Stefany Wedge</h3>
//                 <p className="founders-team__role">babe, Co-Founder</p>
//               </article>
//             </div>

//             {
//               founderDataLoaded &&
//               <div className='col-12'>
//                 {
//                   pageFounderData?.description ?
//                   <div className="text-center w-100 mx-auto text-color-primary pt-3" dangerouslySetInnerHTML={{ __html: pageFounderData?.description }}></div> : null
//                 }
//               </div>
//             }
//           </div>
//         </div>
//       </section> 

//       {/* <section className="Why-babe-exists section-padding">
//         <div className="container">
//           <div className="Why-babe-wrap">
//             <div className="Why-babe-in">
//               {
//                 dataLoaded ?
//                   <>
//                     <div className="text-box">
//                       <h2 className="h2-headline">{pageData?.title}</h2>
//                     </div>
//                     {pageData?.description ? <div className='row align-items-center justify-content-center text-center' dangerouslySetInnerHTML={{ __html: pageData?.description }}></div> : null}
                 
                      
//                   </>
//                   :
//                   <div className='w-100 website-placeholder '>
//                     <Placeholder.Paragraph ac={{ backgroundColor: "red" }} className='mb-3' rowHeight={60} active rows={1} />
//                     <Placeholder.Paragraph ac={{ backgroundColor: "red" }} rowHeight={25} active rows={5} />
//                   </div>
//               }
//             </div>
//           </div>
//         </div>
//       </section> */}

//       <section className="babe-building section-padding">
//         <div className="container">
//           <div className="babe-building__header text-center">
//             <h2 className="babe-building__hey">
//               {dataLoaded && pageData?.title ? pageData.title : 'Hey babe'}
//               <span className="babe-building__heart" aria-hidden="true">♥</span>
//             </h2>
//             <p className="babe-building__lead">
//               We&apos;re building something <strong>amazing</strong> for you.
//             </p>
//           </div>

//           <div className="row align-items-stretch justify-content-center babe-building__grid g-4">
//             <div className="col-lg-5 col-md-6">
//               <div className="babe-building__panel">
//                 <div className="babe-building__icon" aria-hidden="true">
//                   <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                     <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" />
//                     <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.5" />
//                     <path d="M12 3v3M12 18v3M3 12h3M18 12h3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
//                   </svg>
//                 </div>
//                 <h4 className="h4-headline">Our Mission</h4>
//                 <p className="babe-building__copy">
//                   Our mission is to be innovators for women&apos;s wellness, champions for your success through scalable access to what you really need (so you can do it all, or not, or whatever you want - babe, we don&apos;t judge), and help you find your village.
//                 </p>
//               </div>
//             </div>

//             <div className="col-lg-2 col-md-1 d-none d-md-flex justify-content-center">
//               <div className="babe-building__divider">
//                 <span className="babe-building__divider-heart" aria-hidden="true">♥</span>
//               </div>
//             </div>

//             <div className="col-lg-5 col-md-5">
//               <div className="babe-building__panel">
//                 <div className="babe-building__icon" aria-hidden="true">
//                   <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                     <path d="M12 4a5 5 0 0 1 5 5v1.2c0 .9.4 1.7 1 2.3l.4.4a2 2 0 0 1-1.4 3.4H7a2 2 0 0 1-1.4-3.4l.4-.4c.6-.6 1-1.4 1-2.3V9a5 5 0 0 1 5-5z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
//                     <path d="M10 19h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
//                   </svg>
//                 </div>
//                 <h4 className="h4-headline">App Coming Soon</h4>
//                 <p className="babe-building__copy">Boston Market Early Look October 2025</p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* <OutStorySection />

//       <Services /> */}


//     </main>
//   );
// }

// export default WebsiteAboutPage;

import { useEffect, useState } from 'react';
import karliMason from '../../../assets/website/images/Karli-Mason.jpg'
import stefanyWedge from '../../../assets/website/images/Stefany-Wedge.jpg'
import { GetCMSDetails } from '../services/cms.services';
import OutStorySection from './outStory';
import Services from './services';
import { Placeholder } from 'rsuite';


function WebsiteAboutPage() {
  const [pageData, setPageData] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  useEffect(() => {
    setDataLoaded(false);
    GetCMSDetails("why-babe-exists").then((response) => {
      if (response.success) {
        setPageData(response.data)
      }
    }).catch((err) => {
      console.error(err);
    }).finally(() => {
      setDataLoaded(true);
    });
  }, []);

  const [pageFounderData, setPageFounderData] = useState(false);
  const [founderDataLoaded, setFounderDataLoaded] = useState(false);
  useEffect(() => {
    setFounderDataLoaded(false);
    GetCMSDetails("founder-desc").then((response) => {
      if (response.success) {
        setPageFounderData(response.data)
      }
    }).catch((err) => {
      console.error(err);
    }).finally(() => {
      setFounderDataLoaded(true);
    });
  }, []);

  return (
    <main>
      {/* <section className="about-banner-section section-padding">
        <div className="container">
          <div className="banner-content">
            <div className="banner-text section-head">
              <h1 className="h1-headline">
                Supporting women at every stage, because, babe, it ain’t easy
              </h1>
            </div>
          </div>
        </div>
      </section> */}
      <section className="banner-scetion-padding">
        <div className="container">
          <h1 className="heading-1 main-heading-2 text-center">Meet the founders</h1>
        </div>
      </section>

      {/* <section className="babe-born-section">
        <din className="container">
          <div className="text-box">
            <h2 className="h2-headline">babe. was born for you.</h2>
            <p className="body-1">
            babe comes to you, a platform connecting women to trusted, on-demand services. Inclusive of fertility support with egg freezing and IVF injection concierge, pregnancy & postpartum self-care, reliable childcare sourcing, and elder caregiving. babe prioritizes the wellbeing, support, and empowerment of women.{" "}
            </p>
            <p className="body-1">
            Our mission is to be innovators for women’s wellness, champions for your success through scalable access to what you really need (so you can do it all, or not, or whatever you want - babe, we don’t judge), and help you find your village.{" "}
            </p>
          </div>
        </din>
      </section> */}
      <section className="meet-founders section-padding">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-5">
              <div className="team-box">
                <figure className="team-image">
                  <img
                    src={karliMason}
                    alt="team1"
                    className="img-fluid"
                    width="200px"
                    height="200px"
                  />
                </figure>
                <figcaption>
                  <h4 className="h4-headline">Karli Mason</h4>
                  <h6 className="h6-headline">babe, Co-Founder</h6>
                  {/* <p className="body-1">
                    A former wellness editor turned entrepreneur, Amara created
                    babe to be the kind of space she wished existed during her
                    own life transitions
                  </p> */}
                </figcaption>
              </div>
            </div>

            <div className="col-md-5">
              <div className="team-box">
                <figure className="team-image">
                  <img
                    src={stefanyWedge}
                    alt="team1"
                    className="img-fluid"
                    width="200px"
                    height="200px"
                  />
                </figure>
                <figcaption>
                  <h4 className="h4-headline">Stefany Wedge</h4>
                  <h6 className="h6-headline">babe, Co-Founder</h6>
                  {/* <p className="body-1">
                    With a background in integrative health and women’s
                    advocacy, Nyla is the heart behind babe’s wellness
                    initiatives.
                  </p> */}
                </figcaption>
              </div>
            </div>

            {
              founderDataLoaded &&
              <div className='col-12'>
                {
                  pageFounderData?.description ?
                  <div className="text-center w-100 mx-auto text-color-primary pt-3" dangerouslySetInnerHTML={{ __html: pageFounderData?.description }}></div> : null
                }
              </div>
            }
          </div>
        </div>
      </section>

      <section className="Why-babe-exists section-padding">
        <div className="container">
          <div className="Why-babe-wrap">
            <div className="Why-babe-in">
              {
                dataLoaded ?
                  <>
                    <div className="text-box">
                      <h2 className="h2-headline">{pageData?.title}</h2>
                    </div>
                    {pageData?.description ? <div className='row align-items-center justify-content-center text-center' dangerouslySetInnerHTML={{ __html: pageData?.description }}></div> : null}
                    {/* <div className="col-md-5">
                        <div className="our-mission-box">
                          <h4 className="h4-headline">Our Mission</h4>
                          <h6 className="h6-headline">
                            babe is here to walk alongside women through every messy,
                            beautiful, complicated stage of life. Whether it's
                            navigating new motherhood, identity shifts, burnout, or
                            bold beginnings — we offer real support, heartfelt
                            community, and tools designed for you.
                          </h6>
                        </div>
                      </div>

                      <div className="col-md-1 d-none d-md-block">
                        <div className="vertical-divider"></div>
                      </div>

                      <div className="col-md-5">
                        <div className="our-mission-box">
                          <h4 className="h4-headline">Our Vision</h4>
                          <h6 className="h6-headline">
                            We imagine a world where women no longer have to “power
                            through” alone — where asking for help is celebrated, and
                            being in transition doesn’t mean being invisible. We want
                            every woman to feel seen, supported, and rooted in her
                            worth — every step of the way.
                          </h6>
                        </div>
                      </div> */}
                  </>
                  :
                  <div className='w-100 website-placeholder '>
                    <Placeholder.Paragraph ac={{ backgroundColor: "red" }} className='mb-3' rowHeight={60} active rows={1} />
                    <Placeholder.Paragraph ac={{ backgroundColor: "red" }} rowHeight={25} active rows={5} />
                  </div>
              }
            </div>
          </div>
        </div>
      </section>

      {/* <OutStorySection />

      <Services /> */}


    </main>
  );
}

export default WebsiteAboutPage;
